@for (image of images; track image) {
  <div>
    <img class="docimage" [src]="getImageUrl(image)" alt="document image" />
  </div>
}
